import _classnames from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * A tab/menu system for deep inside a page.
 */
function DeepMenu({ children, className }) {
  return (
    <div className={_classnames('DeepMenu', className)}>
      <div className="DeepMenu__inner">{children}</div>
    </div>
  );
}

DeepMenu.propTypes = {
  /**
   * React Children; recommended to be `<DeepMenu.Item />`
   */
  children: PropTypes.node,

  /**
   * A space-delimited list of class names to attach to the `DeepMenu` component's outer `div`
   */
  className: PropTypes.string,
};

DeepMenu.defaultProps = {
  children: undefined,
  className: '',
};

export default DeepMenu;
